// @flow
import client from '../../client'
import getAuthorizedUserId from '../user/getAuthorizedUserId'
import format from '../../utils/format'

// Types
import type { PaymentOption } from '../../api_types'

export type { PaymentOption }

// Constants
export const USER_GET_CREDIT_CARD = '/auth/users/{0}/payment-options/'

/**
 * Get user credit cards
 * @return {Promise|Error} A resolved Promise with the credit cards or Rejected with an Error
 */
export const getCreditCards = (): Promise<Array<PaymentOption>> => {
  const userId = getAuthorizedUserId()
  if (!userId) return Promise.resolve([])

  const endpoint = format(USER_GET_CREDIT_CARD, userId)
  return client.get(endpoint, null).then((response) => response)
}

export default getCreditCards
